import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { ApiException } from './base.models';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}
export function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
export function validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
            validateAllFormFields(control);
        }
    });
}

export function hasError(formGroup: FormGroup,controlName: string, errorName: string) {
    if (!formGroup) return false;
    return formGroup.controls[controlName].hasError(errorName)&&
    (formGroup.controls[controlName].dirty || formGroup.controls[controlName].touched);
}

export function formatDateForTimeZone(date: any,dateFromat: string):string
{
    
  var dateValue = new Date(date);
  var dateFormated: string | null;

  if(dateValue.valueOf())
  {
    // var millis = dateValue.getTime() - new Date().getTimezoneOffset() * 60000;
    // dateValue.setTime(millis);
    var datePipe = new DatePipe("en-EG");
    dateFormated = datePipe.transform(dateValue,dateFromat);
  }
  return dateFormated !;
}
export function generateShortGuid(): string {
    return 'xxxxxx'.replace(/[x]/g, () => {
      const r = Math.random() * 16 | 0;
      return r.toString(16);
    });
  }